import {useEffect, useRef} from "react";
import styles from "./index.module.scss";
/**
 * @param children dropdown에 들어갈 항목들을 넣으세요
 * @description `<div>항목1</div><div>항목2</div><div className={styles.red_color}>항목3</div>`
 * @description 자동으로 드랍다운 스타일링 해줌
 * @param style dropdown 컨테이너의 크기, 위치, overflow등 style
 * @param noRel relative 기준을 다른 상위 컴포넌트에서 주고싶을 때 true (선택)
 * @param closeDropDown 드랍다운 close하는 로직 ex) setIsOpen(false) (선택)
 */
export default function SelectDropDown({style, children, noRel, closeDropDown}) {
  const dropRef = useRef();
  useEffect(() => {
    const handleOutsideClick = e => {
      if (closeDropDown && dropRef.current && !dropRef.current.contains(e.target)) closeDropDown();
    };
    document.addEventListener("click", handleOutsideClick);
    return () => document.removeEventListener("click", handleOutsideClick);
  }, []);
  return (
    <div ref={dropRef} className={!noRel && styles.drop_start}>
      <div className={styles.drop_container} style={{...style}}>
        {children}
      </div>
    </div>
  );
}
